import $ from "jquery";
import Swiper, { Autoplay, EffectCoverflow, Navigation, Pagination } from "swiper";
import { App } from "../../App";

import "./DesignContest.less";

export class AktuellesDesignContest {
    constructor() {
        new App();

        $(".smb-aktuelles-design-contest").toggleClass("smb-hide", false);

        Swiper.use([Navigation, Pagination, Autoplay, EffectCoverflow]);

        new Swiper(".smb-aktuelles-design-contest .smb-content-product .swiper-container", {
            autoplay: {
                delay: 3000,
                disableOnInteraction: true,
            },
            centeredSlides: true,
            coverflowEffect: {
                depth: 500,
                modifier: 1,
                rotate: 0,
                slideShadows: false,
                stretch: 0,
            },
            effect: "coverflow",
            grabCursor: true,
            loop: true,
            pagination: {
                bulletElement: "div",
                clickable: true,
                el: ".swiper-pagination",
                type: "bullets",
            },
            slidesPerView: "auto",
            speed: 300,
        });
    }
}

$((): void => {
    if ($(".smb-aktuelles-design-contest").length > 0) {
        new AktuellesDesignContest();
    }
});